import "./about.css";

import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { TEAM } from "../../data/content";
import { PAGE_ROUTES } from "../../utils/stateTypes";
import Reveal from "../general/Reveal";
import { PageBanner, ImageBand } from "../general/PageParts";

const About = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>ABOUT | PM Skillshouse Foundation</title>
      </Helmet>
      <PageBanner title={"ABOUT"} />

      <section className={"container team"}>
        {TEAM.map((person, i) => (
          <article
            key={person.name}
            className={`team-member ${i % 2 ? "is-flipped" : ""}`}
          >
            <Reveal
              variant={i % 2 ? "right" : "left"}
              className={"team-text"}
            >
              <h2 className={"team-name"}>{person.name}</h2>
              <p className={"team-role"}>{person.role}</p>
              {person.bio.length > 0 && (
                <React.Fragment>
                  <p className={"team-bio-label"}>BIO</p>
                  {person.bio.map((para) => (
                    <p
                      key={para.slice(0, 20)}
                      className={"team-bio"}
                    >
                      {para}
                    </p>
                  ))}
                </React.Fragment>
              )}
              <Link
                to={PAGE_ROUTES.CONTACT}
                className={"btn btn-orange team-contact"}
              >
                CONTACT ME
              </Link>
            </Reveal>
            <Reveal
              variant={"fade"}
              delay={0.1}
              className={"team-photo"}
            >
              <img
                src={person.image}
                alt={person.name}
                width={person.width}
                height={person.height}
                loading={i === 0 ? "eager" : "lazy"}
              />
            </Reveal>
          </article>
        ))}
      </section>

      <ImageBand
        image={"/images/about_strip.jpg"}
        position={"center 40%"}
      />
    </React.Fragment>
  );
};

export default About;
